import { ModalsKeys } from 'global';
import { useModal } from 'hooks/useModal';
import { Dialog, DialogTitle, DialogContent, Stack } from '@mui/material';
import { EquipmentForm } from '../form';
import { EquipmentImageActions } from '../components/EquipmentImageActions';

export const CreateUpdateEquipmentDialog = () => {
  const { isOpen, handleClose, data } = useModal(ModalsKeys.CreateUpdateEquipmentDialog);

  if (!data) throw new Error('Data is required');

  return (
    <Dialog fullWidth maxWidth="lg" open={isOpen} onClose={handleClose}>
      <DialogTitle>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <span>{data.equipmentId ? 'Edit' : 'Create new'} equipment</span>
          <EquipmentImageActions equipmentId={data.equipmentId} onImagesSaved={data.onImagesSaved} />
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <EquipmentForm {...data} />
      </DialogContent>
    </Dialog>
  );
};
